.change-date-input-config {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}
